export function onReady() {
	initializeGridSettings();
	//
	// window.gridSettings.columnApi.applyColumnState({
	// 	state: [{ colId: 'id', sort: 'asc' }],
	// 	defaultState: { sort: null },
	// });

	if (typeof window.customOnGridReady == 'function') {
		window.customOnGridReady.call();
	}
}

function initializeGridSettings() {
	if (typeof(Storage) !== "undefined") {
		let filterKey = '/filter' + window.gridDataUrl;

		var filterSettings = localStorage.getItem(filterKey);
		if (typeof filterSettings !== 'undefined') {
			let filterId = parseInt(filterSettings);
			if (isNaN(filterId)) {
				let filterModel = JSON.parse(filterSettings);
				if (filterModel) {
					window.gridSettings.api.setFilterModel(filterModel);
				}
			} else {
				$('#panel-grid-filter').val(filterId);
				setFilter(filterId);
			}
		}
	}
}

export function setFilter(val) {
	if (val === 'none') {
		window.actualGridFilterSettingsId = null;
		window.gridSettings.api.setFilterModel(null);
	} else {
		var filterModel = $('#grid-filter-' + val).data('filter');
		window.actualGridFilterSettingsId = val;

		if (filterModel) {
			window.gridSettings.api.setFilterModel(filterModel);
		}
	}

	if (typeof(Storage) !== "undefined") {
		let filterKey = '/filter' + window.gridDataUrl;
		localStorage.setItem(filterKey, val);
	}
}

window.setFilter = setFilter;
